import { Gift, Mail, Phone } from "lucide-react";
import { STUDIO } from "@/lib/studio";

const SUBJECT = encodeURIComponent("Gutscheinanfrage – Maison Princess");

export const GiftNote = ({ className = "" }) => (
  <div data-testid="gift-note" className={`flex flex-col gap-4 rounded-[24px] border border-gold/35 bg-paper/90 p-5 sm:flex-row sm:items-center sm:justify-between sm:p-6 ${className}`}>
    <div className="flex items-start gap-4">
      <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-espresso text-gold-light">
        <Gift className="h-5 w-5" strokeWidth={1.5} />
      </span>
      <div>
        <p className="font-serif text-2xl text-ink">Gutscheine schenken?</p>
        <p className="mt-1 text-sm leading-relaxed text-ink-soft">
          Möchtest du jemandem einen Gutschein schenken? Gerne kannst du ihn bei uns anfragen – wir bereiten ihn schnellstmöglich für dich vor.
        </p>
      </div>
    </div>
    <div className="flex shrink-0 gap-2">
      <a href={`mailto:${STUDIO.email}?subject=${SUBJECT}`} data-testid="gift-note-email-btn" className="btn-gold inline-flex items-center gap-2 rounded-full px-5 py-3 text-[11px] font-semibold uppercase tracking-[0.18em]">
        <Mail className="h-4 w-4" /> Anfragen
      </a>
      <a href={STUDIO.phoneHref} data-testid="gift-note-call-btn" aria-label="Gutschein telefonisch anfragen" className="inline-flex items-center gap-2 rounded-full border border-gold/50 px-4 py-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-ink">
        <Phone className="h-4 w-4 text-gold-deep" /> <span className="hidden sm:inline">Anrufen</span>
      </a>
    </div>
  </div>
);
